var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-4"},[_c('strong',{staticClass:"font-bold text-4"},[_vm._t("title")],2),_vm._v(" "),(_vm.$slots.subtitle)?_c('span',{staticClass:"font-light"},[_c('span',{attrs:{"data-test":"subtitle-punctuation-1"}},[_vm._v(" - ")]),_vm._v(" "),_vm._t("subtitle")],2):_vm._e()]),_vm._v(" "),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }